'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var log = require('../log/Log').channel('KayleeTos');

// Returns the Terms of Service for the application, including support for 
// localization in various languages.

var KayleeTosHtml = {
    fromJson: fromJson,
	getTosHtml: getTosHtml,
};

function fromJson(data) {
    var reqProps = [ '$langId' ];
    return FirebaseObject.$fromJson(data, 'TosHtml', reqProps, reqProps,
        function(data) {  return getTosHtml(data.$langId); }
    );
}

// Returns a TosHtml object that contains the HTML when it is loaded. If
// langId is not specified, then the en-us language ID is used.

function getTosHtml(langId) {
    if (typeof langId === 'undefined' || langId === null) {
        langId = 'enUs';
    }

    if (langId !== 'enUs') {
    	log.error(langId + ' is not a supported Tos language');
    }

    var key = 'TosHtml: ' + langId;
    var tos = KayleeCache.get(key);

    if (tos === null) {
        tos = new TosHtml(langId);
        KayleeCache.put(key, tos);
    }

    return tos;
}

function TosHtml(langId) {
    this.$nodeType = 'tosHtml';
    this.$langId = langId;
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('tos/html/' + langId));
}

TosHtml.prototype = Object.create(FirebaseObject.prototype);
TosHtml.prototype.constructor = TosHtml;

TosHtml.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.cal(this,
        [ '$langId' ], {});
};

TosHtml.prototype.toString = function() {
    return '[TosHtml]';
};

module.exports = KayleeTosHtml;